/****************************************************************************************************
*                                                                                                   *
*   Freshwater v3 CLIENT JS FILE                                                                    *
*                                                                                                   *
*   client specific scripts, this file CAN be edited                                                *
*                                                                                                   *
****************************************************************************************************/

window.addEventListener('load', function(e) {
    if (window.Freshwater) {
        window.Freshwater.console('log', "client js loaded. Event: " + e.type);
    }

});

/* ============================================================
   ABJ Variant Picker — Size Guide trigger
   Clicking .abj-size-guide-trigger programmatically clicks
   the popup block's existing modal opener button so we don't
   duplicate modal markup.
   ============================================================ */
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.abj-size-guide-trigger');
  if (!trigger) return;
  var sectionId = trigger.dataset.sizeGuideSection;
  var scope = sectionId
    ? document.getElementById('freshSection--' + sectionId)
    : document;
  var popupBtn = scope ? scope.querySelector('[id^="ProductPopup-"]') : null;
  if (popupBtn) popupBtn.click();
});
